module.exports = __webpack_public_path__ + "img/427.5a4a757c.jpg";